import React, { ReactElement } from 'react'
import Loading from 'components/Utils/Loading'

interface Props {
  isParentLoaded?: boolean
  children: ReactElement
}

export const LoaderSwitcher = ({
  isParentLoaded,
  children
}: Props): ReactElement => {
  return isParentLoaded ? children : <Loading />
}
